import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const navLinks = [
  { label: "Início", href: "/" },
  { label: "Sobre", href: "/sobre" },
  { label: "Serviços", href: "/servicos" },
  { label: "Destinos", href: "/destinos" },
  { label: "Depoimentos", href: "/depoimentos" },
  { label: "Contato", href: "/contato" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  const navBg = scrolled
    ? "bg-[#2E4E72] shadow-lg"
    : "bg-[#2E4E72]/80 backdrop-blur-md";

  return (
    <nav data-testid="navbar" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" data-testid="nav-logo" aria-label="Mahlo Viagens">
            <Logo iconHeight={42} showText />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className={`text-sm font-semibold transition-colors duration-200 text-white/90 hover:text-[#89A6A3] ${
                  location.pathname === link.href ? "text-[#89A6A3]" : ""
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contato"
              data-testid="nav-cta-btn"
              className="bg-[#89A6A3] text-[#2E4E72] font-bold px-6 py-2.5 rounded-full text-sm hover:bg-[#6B8C89] hover:text-white hover:scale-105 transition-all duration-300 shadow-md"
            >
              Reserve Agora
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-btn"
            className="md:hidden p-2 rounded-lg text-white"
            aria-label="Menu"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#2E4E72] border-t border-white/10">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                className={`py-3 px-4 text-white font-semibold rounded-lg hover:bg-white/10 hover:text-[#89A6A3] transition-colors ${
                  location.pathname === link.href ? "bg-white/10 text-[#89A6A3]" : ""
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contato"
              data-testid="mobile-cta-btn"
              className="mt-2 bg-[#89A6A3] text-[#2E4E72] font-bold py-3 px-4 rounded-full text-center hover:bg-[#6B8C89] transition-colors"
            >
              Reserve Agora
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
